<template>
  <div class="project-task">
    <ul class="nav nav-tabs nav-tabs-top nav-justified mb-0">
      <li class="nav-item">
        <a
          class="nav-link active"
          href="#to_do_tasks"
          data-bs-toggle="tab"
          aria-expanded="true"
          >To-Do tasks</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="#in_progress_tasks"
          data-bs-toggle="tab"
          aria-expanded="false"
          >In Progress tasks</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="#completed_tasks"
          data-bs-toggle="tab"
          aria-expanded="false"
          >Completed tasks</a
        >
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane show active" id="to_do_tasks">
        <div class="task-wrapper">
          <div class="task-list-container">
            <div v-if="tasks.length > 0" class="task-list-body">
              <ul id="task-list">
                <li
                  class="task"
                  :class="{ completed: task?.completed }"
                  v-for="(task, index) in tasks"
                  :key="index"
                >
                  <div class="task-container">
                    <!-- <span class="task-action-btn task-check">
                      <span
                        :class="[
                          'action-circle',
                          'large',
                          'complete-btn',
                          { completed: task?.completed },
                        ]"
                        title="Mark Complete"
                        @click="markComplete(index)"
                      >
                        <i class="material-icons">check</i>
                      </span>
                    </span> -->
                    <span class="task-label">{{ task?.text }}</span>
                    <span class="task-action-btn task-btn-right">
                      <span
                        class="action-circle large me-1"
                        title="Edit"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_task"
                        @click="editTask(task.id)"
                      >
                        <i class="material-icons">edit</i>
                      </span>
                      <span
                        class="action-circle large delete-btn"
                        title="Delete Task"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_task"
                        @click="confirmationModal(task)"
                      >
                        <i class="material-icons">delete</i>
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="task-list-body">
              <ul class="task-list">
                <li class="text-center">No Data</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="in_progress_tasks">
        <div class="task-wrapper">
          <div class="task-list-container">
            <div v-if="inProgressTasks.length > 0" class="task-list-body">
              <ul id="task-list">
                <li
                  class="task"
                  :class="{ completed: task?.completed }"
                  v-for="(task, index) in inProgressTasks"
                  :key="index"
                >
                  <div class="task-container">
                    <!-- <span class="task-action-btn task-check">
                      <span
                        :class="[
                          'action-circle',
                          'large',
                          'complete-btn',
                          { completed: task?.completed },
                        ]"
                        title="Mark Complete"
                        @click="markComplete(index)"
                      >
                        <i class="material-icons">check</i>
                      </span>
                    </span> -->
                    <span class="task-label">{{ task?.text }}</span>
                    <span class="task-action-btn task-btn-right">
                      <span
                        class="action-circle large me-1"
                        title="Edit"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_task"
                        @click="editTask(task.id)"
                      >
                        <i class="material-icons">edit</i>
                      </span>
                      <span
                        class="action-circle large delete-btn"
                        title="Delete Task"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_task"
                        @click="confirmationModal(task)"
                      >
                        <i class="material-icons">delete</i>
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="task-list-body">
              <ul class="task-list">
                <li class="text-center">No Data</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="completed_tasks">
        <div class="task-wrapper">
          <div class="task-list-container">
            <div v-if="completedTasks.length > 0" class="task-list-body">
              <ul id="task-list">
                <li
                  class="task"
                  :class="{ completed: task?.completed }"
                  v-for="(task, index) in completedTasks"
                  :key="index"
                >
                  <div class="task-container">
                    <span class="task-label">{{ task?.text }}</span>
                    <span class="task-action-btn task-btn-right">
                      <span
                        class="action-circle large me-1"
                        title="Edit"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_task"
                        @click="editTask(task.id)"
                      >
                        <i class="material-icons">edit</i>
                      </span>
                      <span
                        class="action-circle large delete-btn"
                        title="Delete Task"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_task"
                        @click="confirmationModal(task)"
                      >
                        <i class="material-icons">delete</i>
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="task-list-body">
              <ul class="task-list">
                <li class="text-center">No Data</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit Task Modal -->
  <div id="edit_task" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Task</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            ref="Closeedit"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form
            ref="editForm"
            @submit="updateTask"
            :validation-schema="schema"
            v-slot="{ errors }"
          >
            <div class="row">
              <!-- project -->
              <div class="col-md-12">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Project<span class="text-danger">*</span></label
                  >
                  <Field
                    v-slot="{ value }"
                    name="project_id"
                    as="select"
                    disabled
                    :class="{ 'is-invalid': errors.project_id }"
                    class="form-control"
                  >
                    <option value="" disabled>Select project</option>
                    <option
                      v-for="option in projects"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.project_name }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">
                    {{ errors.project_id }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

              <!-- task_name -->
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Task Name<span class="text-danger">*</span></label
                  >
                  <Field
                    name="task_name"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.task_name }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.task_name }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

              <!-- end date -->
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Due date<span class="text-danger">*</span></label
                  >
                  <Field
                    name="due_date"
                    type="date"
                    class="form-control"
                    :class="{ 'is-invalid': errors.due_date }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.due_date }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

              <!-- priority -->
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Priority<span class="text-danger">*</span></label
                  >
                  <Field
                    v-slot="{ value }"
                    name="priority"
                    as="select"
                    :class="{ 'is-invalid': errors.priority }"
                    class="form-control"
                  >
                    <option value="" disabled>Select priority</option>
                    <option
                      v-for="option in priorities"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">
                    {{ errors.priority }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>
              <!-- status -->
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Status<span class="text-danger">*</span></label
                  >
                  <Field
                    v-slot="{ value }"
                    name="status"
                    as="select"
                    :class="{ 'is-invalid': errors.status }"
                    class="form-control"
                  >
                    <option value="" disabled>Select status</option>
                    <option
                      v-for="option in statuses"
                      :key="option.enum"
                      :value="option.enum"
                    >
                      {{ option.value }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">
                    {{ errors.status }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

              <!-- description -->
              <div class="col-md-12">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Description <span class="text-danger">*</span></label
                  >
                  <Field
                    name="description"
                    type="text"
                    as="textarea"
                    rows="2"
                    class="form-control"
                    :class="{ 'is-invalid': errors.description }"
                  />
                  <div class="invalid-feedback">
                    {{ errors.description }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

              <div><hr /></div>

              <div class="col-12">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Member<span class="text-danger">*</span></label
                  >
                  <Field
                    v-slot="{ field }"
                    name="employee_personal_id"
                    :class="{ 'is-invalid': errors.employee_personal_id }"
                    class="form-control"
                  >
                    <multiselect
                      v-bind="field"
                      v-model="field.value"
                      :options="employees"
                      label="employee_name"
                      track-by="id"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :searchable="false"
                      placeholder="Select Member"
                      :class="{ 'is-invalid': errors.employee_personal_id }"
                    >
                    </multiselect>
                  </Field>
                  <div class="invalid-feedback">
                    {{ errors.employee_personal_id }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>
            </div>

            <div class="submit-section">
              <button ref="editTeamBtn" class="btn btn-primary submit-btn">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Task Modal -->

  <!-- Delete Task Modal -->
  <div class="modal custom-modal fade" id="delete_task" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Task</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  @click="deleteTask(selectedTask.id)"
                  class="btn btn-primary continue-btn"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  ref="Closedelete"
                  class="btn btn-primary cancel-btn"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Task Modal -->
</template>
<script>
import MyTeamProjectService from "@/services/MyTeamProjectService";
import "vue-toast-notification/dist/theme-default.css";
import { notification } from "ant-design-vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Form,
    Field,
    Multiselect,
  },
  props: ["projectTasks", "fetchTasks", "employees", "projects"],
  data() {
    return {
      newTask: "",
      tasks: [
        // { text: "Patient appointment booking", completed: false },
        // { text: "Appointment booking with payment gateway", completed: false },
        // { text: "Doctor available module", completed: true },
        // { text: "Patient and Doctor video conferencing", completed: false },
        // { text: "Private chat module", completed: false },
        // { text: "Patient Profile add", completed: false },
      ],
      inProgressTasks: [],
      completedTasks: [],
      selectedTask: {},
      showInput: false,
      priorities: ["low", "medium", "high"],
      statuses: [
        {
          enum: "to-do",
          value: "To Do",
        },
        {
          enum: "in_progress",
          value: "In Progress",
        },
        {
          enum: "done",
          value: "Done",
        },
      ],
    };
  },
  methods: {
    getSerialNumber(record) {
      const index = this.filteredData?.findIndex(
        (item) => item.id === record.id
      );
      return index + 1;
    },
    toggleTaskInput() {
      this.showInput = !this.showInput;
      if (!this.showInput) {
        this.newTask = "";
      }
    },
    addTask() {
      if (this.newTask.trim() === "") {
        // Show an error message or handle it as needed
        return;
      }

      this.tasks.push({ text: this.newTask, completed: false });
      this.newTask = "";
      this.showInput = false;
    },
    closeTaskPanel() {
      this.showInput = false;
      this.newTask = "";
    },
    markComplete(index) {
      const task = this.tasks[index];
      task.completed = !task?.completed;

      const message = task?.completed
        ? `${task?.text} marked as complete.`
        : `${task?.text} marked as incomplete.`;

      this.$toast.open({
        message,
        type: "default",
      });
    },
    async editTask(id) {
      try {
        const response = await MyTeamProjectService.editTask(id);
        const data = response.data[0];
        this.selectedTask = {
          ...data,
          employee_personal_id: data?.task_member,
        };
        this.$refs.editForm.setValues(this.selectedTask);
      } catch (error) {
        console.log("error editing task", error);
      }
    },
    async updateTask(values) {
      const members = values?.employee_personal_id?.map((el) => {
        return {
          employee_personal_id: el.id,
        };
      });
      delete values?.employee_personal_id;
      values["TaskMember"] = members;
      try {
        const response = await MyTeamProjectService.updateTask(
          this.selectedTask?.id,
          values
        );
        if (response.success == true) {
          this.$refs.editTeamBtn.innerText = "Submitting...";
          notification.open({
            message: response.message,
            placement: "topRight",
            bottom: "50px",
            duration: 3,
            style: {
              width: "350px",
              marginLeft: `${335 - 600}px`,
              background: "#2ab57d",
            },
          });

          // After adding, refresh the data
          await this.fetchTasks();
          this.$refs.editTeamBtn.innerText = "Submit";
          // // Prevent form validation after submission
          this.$refs.Closeedit.click();
        }
      } catch (error) {
        // if (error.response && error.response.status === 400) {
        let message = "";
        if (typeof error?.response?.data?.data === "string") {
          message = error?.response?.data?.data;
        } else {
          message = error.response?.data?.message || "Something Went Wrong!";
        }

        notification.open({
          message,
          placement: "topRight",
          bottom: "10px",
          duration: 3,
          style: {
            width: "350px",
            marginLeft: `${335 - 600}px`,
            background: "#fd625e",
            zIndex: 1001,
          },
        });
        // }
      }
    },
    confirmationModal(task) {
      this.selectedTask = task;
    },
    async deleteTask(id) {
      try {
        const response = MyTeamProjectService.deleteTask(id);
        if ((response.success = true)) {
          notification.open({
            message: "Task has been deleted.",
            placement: "topRight",
            bottom: "50px",
            duration: 3,
            style: {
              width: "350px",
              marginLeft: `${335 - 600}px`,
              background: "#2ab57d",
            },
          });
        }
        await this.fetchTasks();
        this.$refs.Closedelete.click();
      } catch (error) {
        console.log("error deleting task", error);
        notification.open({
          message: "Failed to delete task.",
          placement: "topRight",
          bottom: "50px",
          duration: 3,
          style: {
            width: "350px",
            marginLeft: `${335 - 600}px`,
            background: "#fd625e",
          },
        });
      }
    },
  },
  mounted() {},
  watch: {
    projectTasks: {
      immediate: true, // Run on first load
      deep: true,
      handler(newTasks) {
        if (newTasks && newTasks.length) {
          this.tasks = newTasks
            .filter((el) => el.status === "to-do")
            .map((el) => ({
              id: el.id,
              text: el.task_name,
              completed: false,
            }));
          this.inProgressTasks = newTasks
            .filter((el) => el.status === "in_progress")
            .map((el) => ({
              id: el.id,
              text: el.task_name,
              completed: false,
            }));
          this.completedTasks = newTasks
            .filter((el) => el.status === "done")
            .map((el) => ({
              id: el.id,
              text: el.task_name,
              completed: false,
            }));
          // this.inProgressTasks = newTasks.map((el) => {
          //   if (el.status === "in_progress") {
          //     return {
          //       text: el.task_name,
          //       completed: false,
          //     };
          //   }
          // });
          // this.completedTasks = newTasks.map((el) => {
          //   if (el.status === "done") {
          //     return {
          //       text: el.task_name,
          //       completed: false,
          //     };
          //   }
          // });
        }
      },
    },
  },
  setup() {
    let schema = Yup.object().shape({
      task_name: Yup.string().required("Task Name is required"),
      project_id: Yup.string().required("Project is required"),
      priority: Yup.string().required("Priority is required"),
      due_date: Yup.string().required("Due Date is required"),
      status: Yup.string().required("Status is required"),
      description: Yup.string().required("Description is required"),
      employee_personal_id: Yup.mixed().required("Employee is required"),
    });
    return {
      schema,
    };
  },
};
</script>
